module.exports = __webpack_public_path__ + "static/img/books.2c39c28f.png";